import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

export default function useUrlQuery(query: string) {
  const { search } = useLocation();
  const memo = useMemo(() => new URLSearchParams(search), [search]);
  return memo.get(query);
}
